import { httpService } from '~/Services/Service';
import { salvarEmExcel } from '~/Utils/Helpers';

// W-0779 — Relatório Razão Social (Imob > Relatórios > Contábil)
// Fonte backend: Setpar.APIRest/Controllers/Imob/Relatorios/Contabil/RazaoSocialController.cs
// RoutePrefix: "imob/relatorios/contabil/razao-social" (sem /api/ — APIBASE já cobre).
// RBAC: característica 694; backend nega com 400 (SEC-005, nunca 403).

const BASE = '/imob/relatorios/contabil/razao-social';

// T1 — lista Razões Sociais por filtros (escopo/status/CNPJ/sócios via TVP).
const buscarRazoes = (filtros) => httpService.post(`${BASE}/buscar`, filtros);

// T2 — relatório consolidado (master + 4 datasets condicionais).
const gerarRelatorio = (data) => httpService.post(`${BASE}/relatorio`, data);

// T3 — exportação XLSX (blob → download). salvarEmExcel já trata responseType blob + Content-Disposition.
const exportarXlsx = (data) => salvarEmExcel(data, `${BASE}/exportar-xlsx`);

export default { buscarRazoes, gerarRelatorio, exportarXlsx };
